import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
import { RAImage, RATypography } from "@/components/customs";
import { Col, Row, Grid } from "antd";
const { useBreakpoint } = Grid;

export const AircraftImagesMobile = ({ aircrafts = [], typeName = "" }) => {
	const screens = useBreakpoint();
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const thumbRef = useRef(null);
	const imagesRef = useRef(null);
	const [imagesList, setImagesList] = useState([]);
	const [activeSlide, setActiveSlide] = useState(0);
	const [activeAircraft, setActiveAircraft] = useState();

	useEffect(() => {
		if (aircrafts?.length > 0) {
			let finalImages = [];
			aircrafts?.map((item, index) => {
				item.images?.map((image, indexImage) => {
					finalImages.push({
						...image,
						aircraft_id: item?._id,
						aircraft_name: item?.name,
						tail_number: item?.tail_number,
					});
				});
			});
			setImagesList(finalImages);
		}
	}, [aircrafts]);

	useEffect(() => {
		if (imagesList[activeSlide] && imagesList[activeSlide]?.tail_number !== activeAircraft) {
			setActiveAircraft(imagesList[activeSlide]?.tail_number);
		}
	}, [activeSlide, imagesList]);

	return (
		<Container>
			<Row>
				<Swiper
					ref={imagesRef}
					style={{
						"--swiper-navigation-color": "#fff",
						"--swiper-pagination-color": "#fff",
						"--swiper-navigation-size": "24px",
						"--swiper-navigation-sides-offset": "16px",
					}}
					loop={true}
					navigation={true}
					thumbs={{ swiper: thumbsSwiper }}
					modules={[FreeMode, Navigation, Thumbs]}
					onActiveIndexChange={(e) => {
						setActiveSlide(e.realIndex);
					}}
				>
					{imagesList.length > 0
						? imagesList.map((item, index) => (
								<SwiperSlide
									key={`aircraft-image-${index}`}
									style={{
										position: "relative",
										backgroundColor: "#000",
									}}
								>
									<RAImage url={item?.url} width="100vw" height="100%" />
								</SwiperSlide>
							))
						: null}
				</Swiper>
			</Row>
			<Row>
				<Swiper
					ref={thumbRef}
					onSwiper={setThumbsSwiper}
					spaceBetween={10}
					slidesPerView={screens?.xs ? 3 : 4}
					freeMode={true}
					watchSlidesProgress={true}
					modules={[FreeMode, Navigation, Thumbs]}
					className="mySwiper"
				>
					{imagesList.length > 0
						? imagesList.map((item, index) => (
								<SwiperSlide key={`aircraft-image-${index}`}>
									<RAImage
										url={item?.url}
										borderRadius={4}
										style={{
											width: "100%",
											height: "100%",
											borderRadius: "8px",
										}}
									/>
								</SwiperSlide>
							))
						: null}
				</Swiper>
			</Row>
			<Row justify="center">
				<div style={{ textAlign: "center", padding: "14px" }}>
					<RATypography
						variant="h2"
						color="#fff"
						style={{
							fontSize: "28px",
							lineHeight: "38px",
						}}
					>
						{typeName}
					</RATypography>
					<RATypography
						variant="sub-heading2"
						color="#fff"
						style={{
							fontSize: "16px",
							lineHeight: "24px",
							letterSpacing: "1px",
						}}
					>
						{activeAircraft}
					</RATypography>
				</div>
			</Row>
			<Row
				justify="center"
				align="middle"
				// gutter={12}
				wrap={false}
				style={{ overflow: "scroll", padding: 10 }}
			>
				{aircrafts?.length > 0
					? aircrafts?.map((item, index) => (
							<Col key={`aircraft-images-${index}`} style={{ margin: "0 6px" }}>
								<WrapperConfiguration
									active={item?.tail_number === activeAircraft}
									onClick={() => {
										for (let i = 0; i < imagesList.length; i++) {
											if (imagesList[activeSlide]?.tail_number !== item?.tail_number) {
												if (imagesList[i]?.tail_number === item?.tail_number) {
													thumbRef.current.swiper.slideTo(i);
													imagesRef.current.swiper.slideTo(i);
													break;
												}
											}
										}
									}}
								>
									<RATypography
										variant="sub-heading4"
										color={item?.tail_number === activeAircraft ? "#FFB11A" : "#fff"}
									>
										{item?.tail_number || ""}
									</RATypography>
								</WrapperConfiguration>
							</Col>
						))
					: null}
			</Row>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	background: #000;
	.swiper {
		width: 100%;
		height: 100%;
	}
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
		/* Center slide text vertically */
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
	}
	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.swiper {
		width: 100%;
		height: 300px;
		margin-left: auto;
		margin-right: auto;
	}
	.swiper-slide {
		background-size: cover;
		background-position: center;
	}
	.mySwiper2 {
		height: 60%;
		width: 100%;
	}
	.mySwiper {
		height: 100px;
		box-sizing: border-box;
		padding: 10px 0;
	}
	.mySwiper .swiper-slide {
		width: 25%;
		height: 100%;
		opacity: 0.6;
	}
	.mySwiper .swiper-slide-thumb-active {
		opacity: 1;
	}
	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
const WrapperConfiguration = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 10px 12px;
	gap: 16px;
	min-width: 100px;
	height: 42px;
	border: 1px solid #e9e8e8;
	border-radius: 4px;
	cursor: pointer;
	:hover {
		border: 1px solid #ffb11a;
	}
	${({ active }) =>
		active &&
		`
        border: 1px solid #ffb11a;
    `}
`;
